export const faqslist = [
  {
    id: 1,
    summary: 'What is E-Retail Point?',
    description: 'E-Retail Point is like a helper for your business, specially crafted to fit the needs of small and medium-sized businesses. It is a cloud-based POS (Point Of Sale) Software as a Service (SAAS), which means it is like having your virtual assistant that takes care of all things sales-related. With E-Retail Point, your business can shine brighter and work better.'
  },
  {
    id: 2,
    summary: 'How much does E-Retail Point cost?',
    description: 'Our pricing model is adaptable, tailored to suit the unique requirements of your business. Kindly get in touch with us to receive a customized quotation.'
  },
  {
    id: 3,
    summary: 'Can E-Retail Point be customized for my business?',
    description: 'Yes, our Point Of Sale is for crafting a solution that is a perfect fit for your business. Our team is ready to have a good conversation with you, sort out what ticks all your boxes, and then whip up a tailor-made solution that suits you.'
  },
  {
    id: 4,
    summary: 'Is E-Retail Point easy to use?',
    description: 'Yes, our solution is all about keeping things simple and user-friendly. We have put a lot of thought into creating an interface that is not only intuitive but also visually appealing. As a result, you will be able to navigate through it in no time. On the other hand, we are here to provide you with comprehensive training sessions to help you understand the E-Retail Point better.'
  },
  {
    id: 5,
    summary: 'Is E-Retail Point secure?',
    description: 'Yes, safety is a big deal for us. We are all about making sure your data and customer info are secure. Our solution follows all the security rules alongside some fancy tricks, like encryption and tokenization, to keep things secure.'
  },
  {
    id: 6,
    summary: 'Can E-Retail Point be used on multiple devices?',
    description: 'Yes, our POS solution is cloud-based. You can access it from anywhere with an internet connection. No more worrying about being tied down to a specific computer or location. The cloud-based solution allows you to work on what matters, when it matters, from your chosen device.'
  },
]
